export default "__VITE_ASSET__qfJyvD7o__"